import { useSelectorKiosk } from "./useSelectorKiosk";

const useChatbot = () => {
    const selector = useSelectorKiosk(state => state.chatbot)
    return selector;
}

export default useChatbot;